module.exports = "/cyber/_next/static/images/pc-0dd5e3cabf015864840c4bf7b27d5bdd.png";